import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    loading: false,
    teamMembers: [],
    pagination: null,
    error: null,
    roleUpdateLoading: false,
    statusUpdateLoading: false,
    rejectedStudentsLoading: false,
    rejectedStudents: [],
    rejectedStudentsError: null,
}

export const TeamReducer = createReducer(initialState, (builder) => {
    builder
        // Get Team Members
        .addCase("GetTeamMembersRequest", (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase("GetTeamMembersSuccess", (state, action) => {
            state.loading = false;
            state.teamMembers = action.payload.data || action.payload;
            state.pagination = action.payload.pagination || null;
            state.error = null;
        })
        .addCase("GetTeamMembersFailure", (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.teamMembers = [];
            state.pagination = null;
        })
        .addCase("UpdateTeamMemberRoleRequest", (state) => {
            state.roleUpdateLoading = true;
        })
        .addCase("UpdateTeamMemberRoleSuccess", (state) => {
            state.roleUpdateLoading = false;
        })
        .addCase("UpdateTeamMemberRoleFailure", (state) => {
            state.roleUpdateLoading = false;
        })
        .addCase("UpdateTeamMemberStatusRequest", (state) => {
            state.statusUpdateLoading = true;
        })
        .addCase("UpdateTeamMemberStatusSuccess", (state) => {
            state.statusUpdateLoading = false;
        })
        .addCase("UpdateTeamMemberStatusFailure", (state) => {
            state.statusUpdateLoading = false;
        })
        .addCase("GetRejectedStudentsRequest", (state) => {
            state.rejectedStudentsLoading = true;
            state.rejectedStudentsError = null;
        })
        .addCase("GetRejectedStudentsSuccess", (state, action) => {
            state.rejectedStudentsLoading = false;
            state.rejectedStudents = action.payload;
            state.rejectedStudentsError = null;
        })
        .addCase("GetRejectedStudentsFailure", (state, action) => {
            state.rejectedStudentsLoading = false;
            state.rejectedStudentsError = action.payload;
            state.rejectedStudents = [];
        })
});

